import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
    computed: {
        ...mapGetters({
            profileTitle: 'apiSession/title',
            profileUserId: 'apiSession/userId',
            profileRole: 'apiSession/role',
            profileEmail: 'apiSession/email',
            profileName: 'apiSession/sessionName'
        }),
    },
});
